// extracted by mini-css-extract-plugin
var _1 = "AdminApiView-module__animatedBackground--rdWsy";
var _2 = "AdminApiView-module__footer--nG56g";
var _3 = "AdminApiView-module__footerContact--YMqVq";
export { _1 as "animatedBackground", _2 as "footer", _3 as "footerContact" }
